// SSR-safe storage availability probe.
// See react-rewrite-plan.md section 8.3.

export type StorageKind = 'local' | 'session';

const PROBE_KEY = '__agenthub_storage_probe__';

// Returns true only if the requested Web Storage is present AND can be written
// to. Handles: SSR (no window), private mode where the API throws, and
// quota-exceeded errors. Never throws.
export function isStorageAvailable(kind: StorageKind): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  // Bare `localStorage`/`sessionStorage` reads pick up `vi.stubGlobal` in tests
  // and match the pattern used elsewhere in this codebase.
  const storage = kind === 'local' ? localStorage : sessionStorage;
  if (!storage) {
    return false;
  }
  try {
    storage.setItem(PROBE_KEY, '1');
    const value = storage.getItem(PROBE_KEY);
    storage.removeItem(PROBE_KEY);
    return value === '1';
  } catch {
    // Storage may throw on read/write in private mode or when quota is full.
    // We intentionally treat any failure as "unavailable" so callers can
    // fall back to in-memory defaults without crashing.
    return false;
  }
}
